import {
         findTask, // find
         // printTaskTree
       } from './taskListHelper'

// findVisibleTask
// findNextVisibleTask, findPreviousVisibleTask -> next, previous in tree
// findVisibleSiblingTasks, findNextVisibleSiblingTask, findPreviousVisibleSiblingTask -> siblings
// findNextVisibleSiblingOfSelfOrAncestors
// findYoungestVisibleDescendentRecursive

function findVisibleTask(taskList, taskId, unfoldedTaskIdSet) {
  if (!taskList || !taskId)
    return null
  let matchingList = taskList.filter(task => task.taskId === taskId && !task.filtered)
  if (matchingList.length > 0)
    return matchingList[0]

  let unfilteredList = taskList.filter(task => !task.filtered)
  for (let task of unfilteredList) {
    if (unfoldedTaskIdSet.has(task.taskId) && task.taskList.length > 0) {
      let matchingTask = findVisibleTask(task.taskList, taskId, unfoldedTaskIdSet)
      if (matchingTask)
        return matchingTask
    }
  }
  return null
}

// task itself may not be visible, in that case, return topmost
export function findNextVisibleTask(topTaskList, task, unfoldedTaskIdSet) {
  if (task) {
    task = findVisibleTask(topTaskList, task.taskId, unfoldedTaskIdSet)
  }
  if (!task) { // return topmost visible task
    let visibleTopTasks = topTaskList.filter(task => !task.filtered)
    if (!visibleTopTasks.length)
      return null
    return visibleTopTasks[0]
  }

  // return first child if any
  let visibleChildTasks = task.taskList.filter(childTask => !childTask.filtered && unfoldedTaskIdSet.has(task.taskId))
  if (visibleChildTasks.length > 0) {
    return visibleChildTasks[0]
  }
  return findNextVisibleSiblingOfSelfOrAncestors(topTaskList, task, unfoldedTaskIdSet)
}

// task itself may not be visible, in that case, return bottommost
export function findPreviousVisibleTask(topTaskList, task, unfoldedTaskIdSet) {
  if (task) {
    task = findVisibleTask(topTaskList, task.taskId, unfoldedTaskIdSet)
  }
  if (!task) { // return bottommost visible task
    let visibleTopTasks = topTaskList.filter(task => !task.filtered)
    if (!visibleTopTasks.length)
      return null
    return findYoungestVisibleDescendentRecursive(visibleTopTasks[visibleTopTasks.length-1], unfoldedTaskIdSet)
  }

  let visibleSiblingTasks = findVisibleSiblingTasks(topTaskList, task)
  const index = visibleSiblingTasks.findIndex(siblingTask => siblingTask.taskId === task.taskId)
  if (index === 0) { // return parent if task is to sibling
    return findTask(topTaskList, task.parentTaskId)
  }

  // return older sibling's youngest descendent
  return findYoungestVisibleDescendentRecursive(visibleSiblingTasks[index-1], unfoldedTaskIdSet)
}

// task is assumed to be non-null and visible
function findVisibleSiblingTasks(topTaskList, task) {
  if (task.parentTaskId) {
    let parentTask = findTask(topTaskList, task.parentTaskId)
    if (!parentTask) { // parentTask was deleted from tree when subtree was deleted
      return null
    }
    return parentTask.taskList.filter(task => !task.filtered)
  }
  else {
    return topTaskList.filter(task => !task.filtered)
  }
}

// task is assumed to be non-null and visible
function findNextVisibleSiblingTask(topTaskList, task) {
  let visibleSiblingTasks = findVisibleSiblingTasks(topTaskList, task)
  const index = visibleSiblingTasks.findIndex(siblingTask => siblingTask.taskId === task.taskId)
  if (index < visibleSiblingTasks.length-1) {
    return visibleSiblingTasks[index+1]
  }
  return null
}

// task is assumed to be non-null and visible
/*
function findPreviousVisibleSiblingTask(topTaskList, task) {
  let visibleSiblingTasks = findVisibleSiblingTasks(topTaskList, task)
  const index = visibleSiblingTasks.findIndex(siblingTask => siblingTask.taskId === task.taskId)
  if (index > 0) {
    return visibleSiblingTasks[index-1]
  }
  return null
}
*/

// task is assumed to be non-null and visible
function findNextVisibleSiblingOfSelfOrAncestors(topTaskList, task, unfoldedTaskIdSet) {
  let youngerSiblingTask = findNextVisibleSiblingTask(topTaskList, task)
  if (youngerSiblingTask !== null)
    return youngerSiblingTask

  if (!task.parentTaskId)
    return null
  let parentTask = findTask(topTaskList, task.parentTaskId)
  return findNextVisibleSiblingOfSelfOrAncestors(topTaskList, parentTask, unfoldedTaskIdSet)
}

function findYoungestVisibleDescendentRecursive(task, unfoldedTaskIdSet) {
  if (!unfoldedTaskIdSet.has(task.taskId))
    return task
  let unfilteredChildTasks = task.taskList.filter(task => !task.filtered)
  if (unfilteredChildTasks.length === 0)
    return task
  return findYoungestVisibleDescendentRecursive(unfilteredChildTasks[unfilteredChildTasks.length-1], unfoldedTaskIdSet)
}
